import { render, staticRenderFns } from "./linkAutomation.vue?vue&type=template&id=c6cba110&"
import script from "./linkAutomation.vue?vue&type=script&lang=js&"
export * from "./linkAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports